'use client';

import { forwardRef } from 'react';
import MuiSnackbar, { type SnackbarProps as MuiSnackbarProps } from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

export interface SnackbarProps extends Omit<MuiSnackbarProps, 'anchorOrigin'> {
  severity?: 'success' | 'error' | 'warning' | 'info';
  onClose?: () => void;
}

const ANCHOR_ORIGIN: MuiSnackbarProps['anchorOrigin'] = {
  vertical: 'bottom',
  horizontal: 'right',
};

export const Snackbar = forwardRef<HTMLDivElement, SnackbarProps>(
  ({ severity = 'info', message, onClose, ...props }, ref) => {
    return (
      <MuiSnackbar
        ref={ref}
        autoHideDuration={5000}
        onClose={onClose}
        {...props}
        anchorOrigin={ANCHOR_ORIGIN}
      >
        <MuiAlert onClose={onClose} severity={severity} variant="filled" sx={{ width: '100%' }}>
          {message}
        </MuiAlert>
      </MuiSnackbar>
    );
  }
);

Snackbar.displayName = 'Snackbar';
